import { Purpose } from '@utils/aureus'
import { executeQuery as executeRecommendedContentQuery } from '@utils/aureus/queries/recommendedContent'
import { JSONWidgetType as TeaserStandardHorizontalJSONWidgetType } from '@widgets/TeaserStandardHorizontal'

export type ArticleRecommendationItem =
  TeaserStandardHorizontalJSONWidgetType & {
    aureusOfferId?: string
  }

const getRecommendations = async (
  id: string,
  purpose?: Purpose,
): Promise<ArticleRecommendationItem[]> => {
  const queryResult =
    (await executeRecommendedContentQuery({
      contentId: id,
      purpose,
    })) ?? []

  return queryResult.reduce((acc, curr) => {
    acc.push({
      ...curr.teasers.standardHorizontal,
      aureusOfferId: curr.aureusOfferId,
    } satisfies ArticleRecommendationItem)

    return acc
  }, [] as ArticleRecommendationItem[])
}

export { getRecommendations }
